export default __webpack_public_path__ + "static/media/illustration_room.bdcf775d.jpg";